import React from 'react';
import _ from 'lodash';
import { Checkbox, Divider, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import toast from 'react-hot-toast';
import { useParameterizedQuery } from 'react-fetching-library';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

import { downloadTemplateDocumentAction } from '../../../../../../services/request';
import { useApplication } from '../../../ApplicationsContext';
import PDFPreviewModal from './PDFPreviewModal';

export const TemplateDocuments = () => {
  const { rowData } = useApplication();
  const { query } = useParameterizedQuery(downloadTemplateDocumentAction);
  const [previewUrl, setPreviewUrl] = React.useState(null);

  const handleDownload = async (row, preview = false) => {
    const { payload, error, loading } = await query(row.id);

    if (!error) {
      if (preview) {
        setPreviewUrl(window.URL.createObjectURL(payload));
      } else {
        const url = window.URL.createObjectURL(payload);
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style = 'display: none';
        a.href = url;
        a.download = `${row.file_name}`;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    } else {
      toast.error('Nie udało się pobrać szablonu');
    }
  };

  const Component = () => (
    <Stack direction="column" justifyContent="center" alignItems="left">
      <Typography color="green" sx={{ p: 1 }}>
        Szablony dokumentów
      </Typography>
      {_.map(rowData.template_documents, (item, key) => (
        <div key={key}>
          <Divider flexItem />
          <Stack
            direction="row"
            key={key}
            alignItems="center"
            justifyContent="center"
          >
            <Stack flex="1 1 80%" direction="row" alignItems="center">
              <Tooltip title={<Stack direction="column">
                <Typography variant="caption">Kategoria pliku: {item.category_display}</Typography>
                <Typography variant="caption"> Opis: {item.description}</Typography>
              </Stack>}>
                <Typography variant="caption"><b>{item.name}</b></Typography>
              </Tooltip>
            </Stack>
            <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
            <Stack direction="row" flex="1 1 20%">
              <Stack direction="row" alignItems="center" key={key}>
                <Typography variant="caption">Zapoznano</Typography>
                <Checkbox
                  disabled={true}
                  checked={item.employee_ids_checked.includes(rowData.employee)}
                />
              </Stack>
              <Divider orientation="vertical" flexItem sx={{ ml: 1, mr: 1 }} />
              <Stack direction="row" spacing={0.5}>
                {item.can_preview && <Tooltip title="Pokaż">
                  <IconButton edge="end" aria-label="comments" onClick={() => handleDownload(item, true)}>
                    <RemoveRedEyeIcon color="primary" />
                  </IconButton>
                </Tooltip>}
                <Tooltip title="Pobierz Plik" onClick={() => handleDownload(item)}>
                  <IconButton color="info">
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
              </Stack>
            </Stack>
          </Stack>
        </div>
      ))}
      {previewUrl !== null ? <PDFPreviewModal url={previewUrl} handleClose={() => setPreviewUrl(null)}/> : null}
    </Stack>
  );

  return (
    <Stack direction="column" mb={2}>
      <Component />
      <Divider flexItem />
    </Stack>
  );
};
